import { isQuestionAttempted, isSubmissionChecked } from 'my-core/quiz-utils';

import LoginProtected from 'my-components/LoginProtected';

import Button from '@mui/material/Button';

import { faCommentAltSmile, faLightbulb } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ spacing }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  gap: spacing(1),
  '.PQA-feedbackBtn': { marginLeft: 'auto' },
});

export default function PracticeQuestionActions(props) {
  const {
    onCheckSolution,
    onRetryQuestion,
    onShowFeedback,
    onToggleSolution,
    question,
    secondaryCTAProps,
    showResults,
    solutionRevealed,
    submission,
  } = props;

  const primaryBtnProps = { color: 'primary', variant: 'contained' };
  const secondaryBtnProps = { color: 'primary', variant: 'outlined' };

  const isAttempted = isQuestionAttempted(question, submission);

  const feedbackBtn = onShowFeedback && isSubmissionChecked(submission) && (
    <LoginProtected actionText="Leave Feedback">
      <Button
        className="PQA-feedbackBtn"
        onClick={() => onShowFeedback()}
        size="small"
        startIcon={<FontAwesomeIcon icon={faCommentAltSmile} />}
        variant="contained"
      >
        Feedback
      </Button>
    </LoginProtected>
  );

  if (!showResults) {
    return (
      <div css={rootCss}>
        <Button {...primaryBtnProps} disabled={!isAttempted} onClick={onCheckSolution}>
          {question?.type === 'MarkYourself' ? 'View Solution' : 'Check Submission'}
        </Button>
        {!!onToggleSolution && (
          <Button {...secondaryBtnProps} onClick={onToggleSolution} startIcon={<FontAwesomeIcon icon={faLightbulb} />}>
            {solutionRevealed ? 'Hide Solution' : 'Show Solution'}
          </Button>
        )}
        {secondaryCTAProps && (
          <Button {...secondaryCTAProps} onClick={() => secondaryCTAProps.onClick?.('bottom')} {...secondaryBtnProps} />
        )}
        {feedbackBtn}
      </div>
    );
  }

  if (!onRetryQuestion && !secondaryCTAProps && !onShowFeedback) return null;

  return (
    <div css={rootCss}>
      {onRetryQuestion && (
        <Button {...secondaryBtnProps} onClick={onRetryQuestion}>
          Retry Question
        </Button>
      )}
      {secondaryCTAProps && (
        <Button {...secondaryCTAProps} onClick={() => secondaryCTAProps.onClick?.('bottom')} {...primaryBtnProps} />
      )}
      {feedbackBtn}
    </div>
  );
}
